import React, { useState } from "react";
import BaseModal from "components/BaseModal";
import ShowToast from "components/ShowToast";

export default function UploadDocumentModal({ show, onClose, beneid }) {
  const [bankFile, setBankFile] = useState(null);
  const [panFile, setPanFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleFileChange = (e, type) => {
    const file = e.target.files[0];
    if (file) {
      if (type === "bank") setBankFile(file);
      else setPanFile(file);
    }
  };

  const handleUpload = async () => {
    if (!bankFile && !panFile) {
      return ShowToast("Please select at least one file", "warning");
    }

    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("beneid", beneid);
      if (bankFile) formData.append("bank_passbook", bankFile);
      if (panFile) formData.append("pan", panFile);

      const res = await fetch("https://pro.mokshiq.in/upload_beneficiary_doc", {
        method: "POST",
         headers: {
          'Authorization': `Bearer ${localStorage.getItem("authToken")}`,
        },
        body: formData,
      });

      const data = await res.json();
      if (data.status) {
        ShowToast(data.data || "Uploaded successfully", "success");
        onClose();
      } else {
        ShowToast(data.data || "Upload failed", "danger");
      }
    } catch (error) {
      console.error(error);
      ShowToast("Something went wrong", "danger");
    } finally {
      setLoading(false);
    }
  };

  return (
    <BaseModal
      show={show}
      onClose={onClose}
      title="Upload Documents"
      footerButtons={[
        { label: "Cancel", className: "btn-secondary", dismiss: true },
        { label: "Upload Docs", className: "btn-primary", onClick: handleUpload },
      ]}
    >
      <div className="upload-doc-container">
        {/* Bank Passbook */}
        <div className="form-group mb-3">
          <label>Bank Passbook</label>
          <div className="d-flex align-items-center">
            <input
              type="file"
              accept="image/*"
              onChange={(e) => handleFileChange(e, "bank")}
            />
            <span className="ms-2">
              {bankFile ? bankFile.name : "No file selected"}
            </span>
          </div>
        </div>

        {/* PAN */}
        <div className="form-group mb-3">
          <label>PAN</label>
          <div className="d-flex align-items-center">
            <input
              type="file"
              accept="image/*"
              onChange={(e) => handleFileChange(e, "pan")}
            />
            <span className="ms-2">
              {panFile ? panFile.name : "No file selected"}
            </span>
          </div>
        </div>

        {loading && (
          <div className="text-center mt-3">
            <span>Uploading...</span>
          </div>
        )}
      </div>
    </BaseModal>
  );
}
